export enum Rol {
    Empresa = 'empresa',
    Master = 'master'
}